/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Log_Entry_2_BodyInputs */

const en_how_we_work_log_entry_2_body = /** @type {(inputs: How_We_Work_Log_Entry_2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check the source, rule and affected outputs.`)
};

const lv_how_we_work_log_entry_2_body = /** @type {(inputs: How_We_Work_Log_Entry_2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pārbaudām, kurus avotus, noteikumus un rezultātus izmaiņas ietekmē.`)
};

/**
* | output |
* | --- |
* | "Check the source, rule and affected outputs." |
*
* @param {How_We_Work_Log_Entry_2_BodyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_log_entry_2_body = /** @type {((inputs?: How_We_Work_Log_Entry_2_BodyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Log_Entry_2_BodyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_log_entry_2_body(inputs)
	return en_how_we_work_log_entry_2_body(inputs)
});